export const BANNER_POSITIONS = [7, 34, 64];
